(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-colection-v2"]) return;
  try {
    
  document.addEventListener('click', function (e) {
  const item = e.target.closest('.top-bar-cat .item');

  if (item) {
    const targetFilter = item.getAttribute('data-catfilter');
    const targetSection = document.querySelector(`#${targetFilter}`);

    if (targetSection) {
      const offset = 100; // Offset for fixed header
      const top = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    

  $(document).ready(function(){
    
    // Only run on V2 template
    if (!document.querySelector('.product-template-v2')) {
      console.log('Not V2 template, skipping setSlider');
      return;
    }
    
    console.log('V2 template detected, initializing setSlider');
    
    const setSlider = () => {
      let width = $(window).width();
      const galleryLayout = $('.gallery').attr('class').match(/gallery--layout-(\S+)/)?.[1];
      const $slider = $('.slideshow.product-slideshow');
      
      console.log('setSlider - Width:', width, 'Layout:', galleryLayout);
      
      // Determine if slider should be active
      // Mobile (< 1200) OR desktop non-grid layouts should use slider
      const shouldUseSlider = (width < 1200 || galleryLayout !== 'grid-2');
      
      console.log('Should use slider:', shouldUseSlider);
      
      if (shouldUseSlider) {
        // Initialize slider if not already done
        if (!$slider.hasClass('slick-initialized')) {
          console.log('Initializing Slick slider...');
          try {
            $slider.slick({
              adaptiveHeight: true,
              initialSlide: 0,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false
            });
            console.log('✓ Slick initialized successfully');
          } catch(e) {
            console.error('✗ Slick initialization failed:', e);
          }
        } else {
          console.log('Slick already initialized');
        }
      } else {
        // Desktop grid layout - destroy slider if exists
        if ($slider.hasClass('slick-initialized')) {
          console.log('Destroying Slick for grid layout');
          $slider.slick('unslick');
        }
      }
    }
    
    // Call setSlider after a small delay to ensure DOM is ready
    setTimeout(setSlider, 100);
    
    // Reinitialize on window resize
    $(window).resize(function() {
      setSlider();
    });
    
  });

  document.addEventListener('DOMContentLoaded', function() {
  
    const quantityDuplicate = document.getElementById('quantity-duplicate');
    const quantityInput = document.getElementById('quantity-input');
    
    // Sync quantity values between duplicate and original fields
    function syncQuantity(sourceValue) {
      const value = parseInt(sourceValue) || 1;
      const finalValue = Math.max(1, value); // Minimum quantity is 1
      
      if (quantityDuplicate) quantityDuplicate.value = finalValue;
      if (quantityInput) quantityInput.value = finalValue;
      
      return finalValue;
    }
    
    // Handle duplicate quantity field up/down buttons
    const duplicateButtons = document.querySelectorAll('.quantity-wrappe-duplicate a');
    duplicateButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const currentValue = parseInt(quantityDuplicate.value) || 1;
        const action = this.getAttribute('data-quantity');
        
        let newValue = currentValue;
        
        if (action === 'up-duplicate') {
          newValue = currentValue + 1;
        } else if (action === 'down-duplicate') {
          newValue = Math.max(1, currentValue - 1); // Don't go below 1
        }
        
        syncQuantity(newValue);
      });
    });
    
    // Handle original quantity field up/down buttons
    const originalButtons = document.querySelectorAll('.quantity-wrapper a');
    originalButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const currentValue = parseInt(quantityInput.value) || 1;
        const action = this.getAttribute('data-quantity');
        
        let newValue = currentValue;
        
        if (action === 'up') {
          newValue = currentValue + 1;
        } else if (action === 'down') {
          newValue = Math.max(1, currentValue - 1); // Don't go below 1
        }
        
        syncQuantity(newValue);
      });
    });
    
    // Sync when duplicate input is manually changed
    if (quantityDuplicate) {
      quantityDuplicate.addEventListener('change', function() {
        syncQuantity(this.value);
      });
      quantityDuplicate.addEventListener('input', function() {
        syncQuantity(this.value);
      });
    }
    
    // Sync when original input is manually changed
    if (quantityInput) {
      quantityInput.addEventListener('change', function() {
        syncQuantity(this.value);
      });
      quantityInput.addEventListener('input', function() {
        syncQuantity(this.value);
      });
    }
    
    // Initialize both fields with the same value
    syncQuantity(quantityDuplicate ? quantityDuplicate.value : 1);
    
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    

  (function() {
    // Store original jQuery .owlCarousel method
    if (typeof jQuery !== 'undefined' && jQuery.fn.owlCarousel) {
      const originalOwlCarousel = jQuery.fn.owlCarousel;
      
      // Override .owlCarousel() method
      jQuery.fn.owlCarousel = function(options) {
        // If this is being called on .thumbnails, don't initialize
        if (this.hasClass('thumbnails')) {
          console.log('🚫 Blocked OWL Carousel initialization on .thumbnails');
          return this; // Return jQuery object to maintain chainability
        }
        
        // Otherwise, call original method
        return originalOwlCarousel.apply(this, arguments);
      };
      
      console.log('✓ OWL Carousel blocker installed');
    }
  })();

  $(document).ready(function(){
  
    // Only run on V3 template
    if (!document.querySelector('.product-template-v3')) {
      console.log('Not V3 template, skipping setSlider');
      return;
    }
    
    console.log('V3 template detected, initializing setSlider');
    
    const setSlider = () => {
      let width = $(window).width();
      const galleryLayout = $('.gallery').attr('class').match(/gallery--layout-(\S+)/)?.[1];
      const $slider = $('.slideshow.product-slideshow');
      
      console.log('setSlider - Width:', width, 'Layout:', galleryLayout);
      
      // Slider should be active if:
      // 1. Mobile (< 1200px) for ALL layouts
      // 2. Desktop carousel layouts (carousel-beside, carousel-under)
      const isMobile = width < 1200;
      const isCarouselLayout = ['carousel-beside', 'carousel-under'].includes(galleryLayout);
      const shouldUseSlider = isMobile || isCarouselLayout;
      
      console.log('Mobile:', isMobile, 'Carousel layout:', isCarouselLayout);
      console.log('Should use slider:', shouldUseSlider);
      
      if (shouldUseSlider) {
        // Initialize slider if not already done
        if (!$slider.hasClass('slick-initialized')) {
          console.log('Initializing Slick slider...');
          try {
            $slider.slick({
              adaptiveHeight: true,
              initialSlide: 0,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false
            });
            console.log('✓ Slick initialized successfully');
          } catch(e) {
            console.error('✗ Slick initialization failed:', e);
          }
        } else {
          console.log('Slick already initialized');
        }
      } else {
        // Desktop non-carousel layouts - destroy slider if exists
        if ($slider.hasClass('slick-initialized')) {
          console.log('Destroying Slick for non-carousel layout on desktop');
          $slider.slick('unslick');
        }
      }
    }
    
    // Call setSlider after a small delay to ensure DOM is ready
    setTimeout(setSlider, 100);
    
    // Reinitialize on window resize
    let resizeTimer;
    $(window).resize(function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setSlider, 300);
    });
    
  });

  document.addEventListener('DOMContentLoaded', function() {
  
    const quantityDuplicate = document.getElementById('quantity-duplicate');
    const quantityInput = document.getElementById('quantity-input');
    
    // Sync quantity values between duplicate and original fields
    function syncQuantity(sourceValue) {
      const value = parseInt(sourceValue) || 1;
      const finalValue = Math.max(1, value); // Minimum quantity is 1
      
      if (quantityDuplicate) quantityDuplicate.value = finalValue;
      if (quantityInput) quantityInput.value = finalValue;
      
      return finalValue;
    }
    
    // Handle duplicate quantity field up/down buttons
    const duplicateButtons = document.querySelectorAll('.quantity-wrappe-duplicate a');
    duplicateButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const currentValue = parseInt(quantityDuplicate.value) || 1;
        const action = this.getAttribute('data-quantity');
        
        let newValue = currentValue;
        
        if (action === 'up-duplicate') {
          newValue = currentValue + 1;
        } else if (action === 'down-duplicate') {
          newValue = Math.max(1, currentValue - 1); // Don't go below 1
        }
        
        syncQuantity(newValue);
      });
    });
    
    // Handle original quantity field up/down buttons
    const originalButtons = document.querySelectorAll('.quantity-wrapper a');
    originalButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const currentValue = parseInt(quantityInput.value) || 1;
        const action = this.getAttribute('data-quantity');
        
        let newValue = currentValue;
        
        if (action === 'up') {
          newValue = currentValue + 1;
        } else if (action === 'down') {
          newValue = Math.max(1, currentValue - 1); // Don't go below 1
        }
        
        syncQuantity(newValue);
      });
    });
    
    // Sync when duplicate input is manually changed
    if (quantityDuplicate) {
      quantityDuplicate.addEventListener('change', function() {
        syncQuantity(this.value);
      });
      quantityDuplicate.addEventListener('input', function() {
        syncQuantity(this.value);
      });
    }
    
    // Sync when original input is manually changed
    if (quantityInput) {
      quantityInput.addEventListener('change', function() {
        syncQuantity(this.value);
      });
      quantityInput.addEventListener('input', function() {
        syncQuantity(this.value);
      });
    }
    
    // Initialize both fields with the same value
    syncQuantity(quantityDuplicate ? quantityDuplicate.value : 1);
    
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  
  var metafieldCount = parseInt(productRecommendationsSection.dataset.metafieldCount) || 0;
  var totalNeeded = parseInt(productRecommendationsSection.dataset.totalNeeded) || 4;
  
  // Only fetch if we need more products
  // If metafield already has enough products, don't replace content
  if (metafieldCount >= totalNeeded) {
    console.log('Already have enough products from metafield');
    return;
  }
  
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      
      var newContent = container.querySelector(".product-recommendations");
      if (newContent) {
        // Only replace if we have metafield products
        // This ensures the combination of metafield + recommendations shows
        productRecommendationsSection.innerHTML = newContent.innerHTML;
        
        // Re-initialize theme functions
        if (typeof theme !== 'undefined') {
          if (theme.ProductBlockManager && theme.ProductBlockManager.loadImages) {
            theme.ProductBlockManager.loadImages(productRecommendationsSection);
          }
          if (theme.initAnimateOnScroll) {
            theme.initAnimateOnScroll();
          }
        }
      }
    }
  };
  request.send();
};

// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});

// Fetch recommendations on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadProductRecommendationsIntoSection);
} else {
  loadProductRecommendationsIntoSection();
}

  } catch(e) { console.error(e); }
})();
})();
